import React from "react";
import PropTypes from "prop-types";
import WarningTwoToneIcon from '@material-ui/icons/WarningTwoTone';
import WarningRoundedIcon from '@material-ui/icons/WarningRounded';
import Tooltip from '@material-ui/core/Tooltip';
import { withStyles, makeStyles } from '@material-ui/core/styles';

const LightTooltip = withStyles((theme) => ({
    tooltip: {
      backgroundColor: theme.palette.common.white,
      color: 'rgba(0, 0, 0, 0.87)',
      boxShadow: theme.shadows[1],
      fontSize: 13,
    },
  }))(Tooltip);
export default class MenuButton extends React.PureComponent {
    render() {
        let { image, text, onClick, isActive, onDelete, onSelect, photoId, isChecked, isCorrected, onMouseDown, isQcMode, fileSize, isTooSmall } = this.props;

        return (
            <div className={'menu-button' + (isCorrected ? ' corrected': '') + (isActive ? ' active' : '')} >
                <div className={'image-container'}>
                    <img src={image} alt={text} onClick={onClick} onMouseDown={onMouseDown}/>
                </div>
                <div className={'text'}>{text}</div>
                <div className={'text size'}>{fileSize}&nbsp;{isTooSmall && <LightTooltip className="blackcolor" title="Image is too small, should be at least 2560×1440 (3.6 megapixels)" placement="right"><WarningRoundedIcon color="error" htmlColor="#ff0000" style={{ color: 'yellow', fill: 'yellow', fontSize: '20px', height: '20px' }} fontSize="large" className={'exclamation'}/></LightTooltip>}</div>
                {!isQcMode &&
                <div className={'closer'} onClick={(e) => {
                    e.stopPropagation();
                    onDelete()
                }}></div> }
                {!isQcMode &&
                <input className={'check'} type={'checkbox'} value={photoId} checked={isChecked} onChange={(e) => {
                    e.stopPropagation();
                    if (onSelect) onSelect(photoId);
                }}  /> }
            </div>
        )
    }
}

MenuButton.propTypes = {
    image: PropTypes.node,
    text: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
    onDelete: PropTypes.func.isRequired,
    isActive: PropTypes.bool.isRequired,
};
